import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { en } from "./locales/en";
import { ko } from "./locales/ko";

const STORAGE_KEY = "argos_lang";

function getInitialLang(): "ko" | "en" {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === "en" || saved === "ko") return saved;
  } catch {
    // localStorage 없음 — 기본값
  }
  // 브라우저 언어 — 한국어 우선 (ACC 정체성)
  if (typeof navigator !== "undefined" && navigator.language?.startsWith("en")) {
    return "en";
  }
  return "ko";
}

i18n.use(initReactI18next).init({
  resources: {
    ko: { translation: ko },
    en: { translation: en },
  },
  lng: getInitialLang(),
  fallbackLng: "ko",
  interpolation: { escapeValue: false },  // React 가 escape
});

export function setLanguage(lng: "ko" | "en"): void {
  i18n.changeLanguage(lng);
  try {
    localStorage.setItem(STORAGE_KEY, lng);
  } catch {
    // localStorage 없음 — silent
  }
}

export default i18n;
